import type {
  KBConfigOptionChoice,
  KBConfigOptionGroup,
} from "@/lib/api/agent";

// Boolean option groups carry no `choices` — the group *is* the switch, and its own id is
// what lands in `declared_variants` (knowledge-base/equipments/*/variants.yaml). Synthesize
// one chip so Rakenne and Kyvykkyydet stay togglable the same way. Enum groups render one
// chip per declared choice.
export function chipsForOptionGroup(
  group: KBConfigOptionGroup,
): KBConfigOptionChoice[] {
  if (group.type !== "boolean") return group.choices;
  return [
    {
      id: group.id,
      name_fi: group.name_fi,
      description_fi: group.description_fi,
      enables_behaviors: group.enables_behaviors,
      disables_behaviors: group.disables_behaviors,
      enables_components: group.enables_components,
      disables_components: group.disables_components,
    },
  ];
}
